import { createStyles, makeStyles } from '@hawkins/styles';
import { VERTICAL_NAV_COLLAPSED_WIDTH } from './verticalNavigation.styles';
export var navigationUserControlsStyles = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the actions button group when the button group is oriented horizontally. */
        actionsButtonGroupHorizontal: {
            width: 'auto',
        },
        /** Class name of the actions container when in a non-collapsed vertical navigation component. */
        actionsContainerVerticalExpanded: {
            marginLeft: 'auto',
        },
        /** Class name of each action icon. */
        icon: {},
        /** Class name of each action icon when in a transparent navigation component. */
        iconTransparent: {
            color: hawkins.persistent.iconFillWhiteRegular,
        },
        /** Class name of each disabled action `Button`. */
        iconButtonDisabled: {
            '& $iconTransparent': { color: hawkins.persistent.iconFillWhiteXlight },
        },
        /** Class name of the root element. */
        root: {
            alignItems: 'center',
            display: 'flex',
            width: '100%',
        },
        /** Class name of the root element when in a collapsed vertical navigation component. */
        rootVerticalCollapsed: {
            flexDirection: 'column',
            padding: "".concat(hawkinsVariables.spacings.space5, " 0"),
            width: VERTICAL_NAV_COLLAPSED_WIDTH,
        },
        /** Class name of the root element when in a non-collapsed vertical navigation component. */
        rootVerticalExpanded: {
            padding: hawkinsVariables.spacings.space5,
        },
        /** Class name of the user menu caret. */
        userMenuCaret: {},
        /** Class name of the user menu caret when in a transparent navigation component. */
        userMenuCaretTransparent: {
            color: hawkins.persistent.iconFillWhiteRegular,
        },
        /** Class name of the user menu caret when in a collapsed vertical navigation component. */
        userMenuCaretVerticalCollapsed: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-Icon': { display: 'none' },
        },
        /** Class name of the user menu container when in a horizontal navigation. */
        userMenuContainerHorizontal: {
            marginLeft: hawkinsVariables.spacings.space6,
            '&:first-child': { marginLeft: 0 },
        },
        /** Class name of the user menu container when in a collapsed vertical navigation component. */
        userMenuContainerVerticalCollapsed: {
            display: 'flex',
            marginTop: hawkinsVariables.spacings.space5,
            '&:first-child': { marginTop: 0 },
        },
        /** Class name of the user menu container when in a non-collapsed vertical navigation component. */
        userMenuContainerVerticalExpanded: {
            order: -1,
            display: 'flex',
        },
    });
};
export var useNavigationUserControlsStyles = makeStyles(navigationUserControlsStyles, {
    name: 'Hawkins-NavigationUserControls',
});
